import { CoreCommonModule } from '@core/common.module';

import { HeaderEnterpriseComponent } from './header-enterprise.component';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import {  NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';


const routes = [
  {
    path: '',
    component: HeaderEnterpriseComponent,
    data: { animation: 'header-enterprise' },
  }
];
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};
@NgModule({
  declarations: [HeaderEnterpriseComponent],
  exports: [HeaderEnterpriseComponent],
  imports: [
    CoreCommonModule, PipesModule,  NgbDropdownModule, PerfectScrollbarModule, CoreTouchspinModule, 
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
})
export class HeaderEnterpriseModule { }
